import { api } from "@state/apiSlice";
import { Tags } from "@state/apiSlice/tags";


import { SubmitDataMappingParams, GetBoardDataMappingResponse, CustomMappingFieldsResponse } from "@hz/common/api-types/board";
import { Message } from "@hz/common/api-types/index";

const boardRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
     getDataMapping: build.query<GetBoardDataMappingResponse, {boardId: number}>({
      query: ({ boardId }) => ({
        url: `/board/${boardId}/data-mapping`,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: [{ type: Tags.DataMapping }],
    }),
    submitDataMapping: build.mutation<Message, SubmitDataMappingParams>({
      query: ({ boardId, entityType, mappings, syncFromDate }) => ({
        url: `/board/${boardId}/data-mapping`,
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          boardId,
          entityType,
          mappings,
          syncFromDate,
        },
        method: "POST",
      }),
      invalidatesTags: [{ type: Tags.DataMapping }],
    }),
    gmcMappingOptions: build.query<CustomMappingFieldsResponse, { boardId: number }>({
      query: ({ boardId }) => ({
        url: `/board/${boardId}/mapping/options`,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    syncBoard: build.query<Message, void>({
      query: () => ({
        url: `/sync/board`,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

  }),
});

export default boardRequestsSlice;
